import { apiClient, type CreatePartnerToSubPartnerDto } from '@/libs/api'

export type CreatePartnerToSubPartnerRequest = {
  tenantKey: string
  dto: CreatePartnerToSubPartnerDto
}

export const createPartnerToSubPartner = async ({
  tenantKey,
  dto
}: CreatePartnerToSubPartnerRequest) => {
  const { data, errors } = await apiClient
    ._tenant(tenantKey)
    .partner_to_sub_partner.$post({ body: dto })
  return { data, errors }
}
